import * as S from '../styles';

import { RiCheckFill } from 'react-icons/ri';
import { useCorporateFlags } from '@/hooks';

interface StepProps {
    step: any,
    isComplete: boolean,
    isActive: boolean,
    index: number,
    totalLength: number
}

export const Step: React.FC<StepProps> = ({ step, isComplete, isActive, index, totalLength }) => {
    const { brandTheme } = useCorporateFlags();
    return (
        <S.StepWrapper key={step.name}>
            <S.StepLabel>{step.name}</S.StepLabel>
            <S.Mark $isActive={isActive} $isComplete={isComplete} $bgcolor={brandTheme.bg_tertiary_color}>
                {isComplete && (
                    <RiCheckFill />
                )}
            </S.Mark>
            {
                index < totalLength - 1 && (
                    <S.Conector $isActive={isComplete} $bgcolor={brandTheme.bg_tertiary_color} />
                )
            }
        </S.StepWrapper>
    )
}